/*global Stripe */
import $ from 'jquery'

//stripe constants

let stripe, elements, language, translations

const style = {
  base: {
    color: '#32325d',
    fontSize: '16px',
    '::placeholder': {
      color: 'rgba(10, 20, 25, 0.5)'
    },
    ':-webkit-autofill': {
      color: '#32325d'
    },
    fontWeight: 500,
    lineHeight: '28px'
  },
  invalid: {
    color: '#fa755a',
    iconColor: '#fa755a',
    ':-webkit-autofill': {
      color: '#fa755a'
    }
  }
}

// HTML helpers
//
function validateForm(paymentEl) {
  paymentEl.addClass('was-validated')
  return paymentEl[0].checkValidity()
}

function handleError(paymentEl, error) {
  if (error.error) {
    displayErrorIn(paymentEl, error)
    setFormProcessing(paymentEl, false)
  } else {
    throw error
  }
}

function displayErrorIn(paymentEl, event) {
  const el = $('.payment-form__errors', paymentEl)
  if (event.error) {
    el.text(event.error.message)
  } else if (event.type === 'validation_error') {
    el.text(event.message)
  } else {
    el.text('')
  }
}

function setFormProcessing(paymentEl, isLoading) {
  $('.btn-payment-submit', paymentEl).prop('disabled', isLoading)
  $('.loading', paymentEl).toggleClass('d-none', !isLoading)
}

// utils

async function postJSON(url, data) {
  const response = await fetch(url, {
    method: 'post',
    headers: {
      'Content-type': 'application/json',
      'X-CSRFToken': window.csrftoken
    },
    //credentials: 'include',
    body: JSON.stringify(data)
  })
  const result = await response.json()
  if (result.error) {
    throw result
  }
  return result
}

// stripe

function setupStripe(publishableKey, language_code, translations_json) {
  language = language_code
  stripe = Stripe(publishableKey)
  elements = stripe.elements()
  translations = translations_json
}

function setupCard(paymentEl) {
  const stripeEl = $('.payment-form__stripe-element', paymentEl)

  const card = elements.create('card', { style: style })
  card.mount(stripeEl.get(0))

  card.on('change', function(event) {
    displayErrorIn(paymentEl, event)
  })

  return card
}

function setupSepa(paymentEl) {
  const stripeEl = $('.payment-form__stripe-element', paymentEl)

  const options = {
    style,
    supportedCountries: ['SEPA'],
    placeholderCountry: 'SI'
  }
  const iban = elements.create('iban', options)
  iban.mount(stripeEl.get(0))

  iban.on('change', function(event) {
    displayErrorIn(paymentEl, event)
  })

  return iban
}

function setupCreateSubscriptionSepa() {
  const paymentEl = $('#sepa-form')
  const iban = setupSepa(paymentEl)

  const handleSubmit = async evt => {
    evt.preventDefault()

    let result

    const billing_details = {
      name: $('[name=name]', paymentEl).val(),
      email: $('[name=email]', paymentEl).val()
    }

    displayErrorIn(paymentEl, {})

    if (!validateForm(paymentEl)) {
      return
    }

    setFormProcessing(paymentEl, true)

    try {
      // getSepaSetupIntentClientSecret
      result = await postJSON(`/${language}/stripe/setup-sepa/`, {})

      // confirmSepaDebitSetup
      result = await stripe.confirmSepaDebitSetup(result.client_secret, {
        payment_method: {
          sepa_debit: iban,
          billing_details
        }
      })
      if (result.error) {
        throw result
      }

      // createSubscription
      const payment_method = result.setupIntent.payment_method
      result = await postJSON(`/${language}/stripe/create-subscription/`, {
        payment_method
      })

      window.location.href = result.url
    } catch (error) {
      handleError(paymentEl, error)
    }
  }

  paymentEl.on('submit', handleSubmit)
}

function setupCreateSubscriptionCard() {
  const paymentEl = $('#card-form')
  const card = setupCard(paymentEl)
  let subscription, url, setupIntent, paymentIntent

  const handleSubmit = async evt => {
    let result
    const billing_details = {
      name: $('[name=card-name]').val()
    }

    displayErrorIn(paymentEl, {})

    evt.preventDefault()
    if (!validateForm(paymentEl)) {
      return
    }

    setFormProcessing(paymentEl, true)
    try {
      result = await stripe.createPaymentMethod({
        type: 'card',
        card,
        billing_details
      })
      if (result.error) {
        throw result
      }
      const payment_method = result.paymentMethod.id

      const retryInvoice =
        subscription &&
        subscription.latest_invoice &&
        subscription.latest_invoice.payment_intent &&
        subscription.latest_invoice.payment_intent.status ==
          'requires_payment_method'
      if (retryInvoice) {
        // retryInvoiceWithNewPaymentMethod
        const invoice = await postJSON(`/${language}/stripe/retry-invoice/`, {
          payment_method,
          invoice_id: subscription.latest_invoice.id
        })
        setupIntent = null
        paymentIntent = invoice.payment_intent
      } else {
        // createSubscription
        result = await postJSON(`/${language}/stripe/create-subscription/`, {
          payment_method
        })
        subscription = result.subscription
        url = result.url
        setupIntent = subscription.pending_setup_intent
        paymentIntent = subscription.latest_invoice.payment_intent
        console.log('setupIntent', setupIntent)
      }

      // handleCardSetupRequired
      // Some payment methods require a customer to do additional
      // authentication with their financial institution.
      // Eg: 2FA for cards.
      if (setupIntent && setupIntent.status === 'requires_action') {
        result = await stripe.confirmCardSetup(setupIntent.client_secret, {
          payment_method
        })
        if (result.error) {
          throw result
        }
      }

      console.log('setupIntent', setupIntent)
      console.log('paymentIntent', paymentIntent)

      //handlePaymentThatRequiresCustomerAction
      const requiresConfirmCardPayment =
        paymentIntent &&
        (paymentIntent.status === 'requires_action' ||
          paymentIntent.status === 'requires_payment_method')
      if (requiresConfirmCardPayment) {
        result = await stripe.confirmCardPayment(paymentIntent.client_secret, {
          payment_method
        })
        if (result.error) {
          throw result
        }
      }

      //handleRequiresPaymentMethod
      if (
        subscription.status !== 'active' &&
        subscription.latest_invoice.payment_intent.status ===
          'requires_payment_method'
      ) {
        throw { error: { message: translations.cardDeclined } }
      }

      window.location.href = url
    } catch (error) {
      handleError(paymentEl, error)
    }
  }

  paymentEl.on('submit', handleSubmit)
}

function setupSubscription() {
  setupCreateSubscriptionSepa()
  setupCreateSubscriptionCard()
}

window.setupStripe = setupStripe
window.setupSubscription = setupSubscription
